<div class="view-instructions-container">
  <div class="col-full" id="header">
    <p class="sdps-title-3">
      Automatic Mutual Fund Investing
      <information-message></information-message>
    </p>
    <div class="sdps-grid-container col-12 master-account-search-container">
      <div class="col-3">
        <div class="sdps-form-element">
          <label class="master-account-search-label"> Search for a master account</label>
          <div>
            <account-search
              [isMasterAccountSearch]="true"
              [selectedValue]="selectedMasterAccountWithName"
              (selected)="masterAccountSelected($event)"
              (blankAccountField)="getInstructionsForAllMasters(true)">
            </account-search>
          </div>
        </div>
      </div>
      <sdps-divider class="sdps-m-horizontal_large" variation="primary" orientation="vertical"></sdps-divider>
      <div class="sdps-flex">
        <button type="button" class="btn btn-success create-new-button" style="margin-top: 20px" (click)="createNew()">
          Create new instruction
        </button>
      </div>
    </div>
  </div>

  @if (masterAccountList.length > 0) {
    <div class="sdps-grid-container sdps-wrap" id="table-content">
      <div class="instructions-grid-div">
        <div class="instructions-grid-header">
          <div class="aip-grid-icon-header">
            @if (results) {
              <div class="aip-grid-header-left" [innerText]="results"></div>
            }
            @if (filtersApplied) {
              <div
                class="aip-grid-header-left"
                style="font-weight: normal"
              [innerText]="filtersApplied"></div>
            }
            <a href="" class="aip-grid-reset-default clear-all-styling" (click)="resetFilter($event)">Clear all</a>
            <span class="custom-divider-vertical">|</span>
            <a href="" class="aip-grid-reset-default" (click)="resetToDefault($event)">Reset to default</a>
            <div class="export">
              <a class="export-link" [ngClass]="isExportDisabled ? 'export-link-disabled' : ''" (click)="exportButtonClick()"
                ><img class="export-icon" [src]="exportIcon" />Export</a
                >
              </div>
            </div>
          </div>
          <!--AG Grid Insert here-->
          <div class="instructions-grid-area sac-ag-grid short-name">
            <ag-grid-angular
              #viewInstructionsGrid
              class="ag-grid ag-theme-material"
              [defaultColDef]="defaultColDef"
              [columnDefs]="colDefs"
              [gridOptions]="gridOptions"
              [domLayout]="domLayout"
              (gridReady)="onGridReady($event)"
              [paginationPageSize]="50"
              [pagination]="true"
              [suppressPaginationPanel]="true"
              [noRowsOverlayComponent]="noResultMessageComponent"
              [noRowsOverlayComponentParams]="noRowsOverlayComponentParams"
              [loadingOverlayComponent]="loadingOverlayComponent"
              [loadingOverlayComponentParams]="loadingOverlayComponentParams"
              (filterChanged)="onFilterChanged($event)"
              [components]="frameworkComponents">
            </ag-grid-angular>
          </div>
          @if (showPaginationBar) {
            <div class="pagination-bar-bottom">
              <app-pagination-bar [gridApi]="gridApi" [page]="currentPage"></app-pagination-bar>
            </div>
          }
        </div>
      </div>
    }
  </div>
